import React from 'react';
import { TextField } from '@iqueue/iq-ui';

/**
 * Convenience wrapper over the compound iq-ui TextField
 * (<TextField.Root><TextField.Label/><TextField.Input/></TextField.Root>).
 * Same simple API everywhere: label, value, onChange(value), multiline, rows…
 */
export default function Field({
  label, value, onChange, type = 'text', multiline, rows, required, autoFocus,
  autoComplete, placeholder, description, variant = 'outlined', list, disabled,
}) {
  return (
    <TextField.Root variant={variant}>
      {label && <TextField.Label>{label}</TextField.Label>}
      <TextField.Input
        type={multiline || rows ? undefined : type}
        value={value == null ? '' : value}
        onChange={(e) => onChange && onChange(e.target.value)}
        multiline={multiline}
        rows={rows}
        required={required}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        placeholder={placeholder}
        list={list}
        disabled={disabled}
      />
      {description && <TextField.Description>{description}</TextField.Description>}
    </TextField.Root>
  );
}
